import { useNavigate, useRouter } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'

export function NotFoundError() {
  const navigate = useNavigate()
  const { history } = useRouter()
  return (
    <div className='relative h-svh overflow-hidden bg-background'>
      <div className='before:absolute before:inset-0 before:bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,hsl(var(--primary)/0.08),transparent)]' />
      <div className='relative m-auto flex h-full w-full flex-col items-center justify-center'>
        <span className='text-xs font-mono uppercase tracking-[0.3em] text-muted-foreground'>
          Error 404
        </span>
        <h1 className='text-[10rem] sm:text-[14rem] font-bold leading-none tracking-tighter text-transparent bg-clip-text bg-gradient-to-b from-foreground/20 to-foreground/5'>
          404
        </h1>
        <span className='text-2xl font-semibold tracking-tight mt-2'>
          Page Not Found
        </span>
        <p className='text-muted-foreground text-center max-w-sm leading-relaxed mt-2'>
          It seems like the page you're looking for
          does not exist or might have been removed.
        </p>
        <div className='w-16 h-px bg-border my-4' />
        <div className='flex gap-4'>
          <Button variant='ghost' onClick={() => history.go(-1)}>
            Go Back
          </Button>
          <Button onClick={() => navigate({ to: '/' })}>Back to Home</Button>
        </div>
      </div>
    </div>
  )
}
